module.exports = __webpack_public_path__ + "img/background.a568162c.svg";